module.exports = __webpack_public_path__ + "img/logo.e932789e.png";